import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gax-page-header-title',
  templateUrl: './page-header-title.component.html',
  styleUrl: './page-header-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PageHeaderTitleComponent {}
